import styled from "styled-components";

export const CarouselItemAnchor = styled.a(() => ({
    width: "98vw",
    height: "100px",
    cursor: "pointer",
    "-webkit-tap-highlight-color": "transparent",
}));

export const Fallback = styled.div(() => ({
    width: "100%",
    height: "100%",
}));

export const ImageWrapper = styled.div(() => ({
    width: "96vw",
    height: "auto",
}));
